export { default } from './AppBar';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/AppBar/index.js
// module id = 535
// module chunks = 2